import React from 'react';
import keys from 'lodash/keys';
import { socialIconsByServiceName } from 'zoomforth_component_lib/social_icons.jsx';

const VALID_SOCIAL_LINK_SERVICE_NAMES = keys(socialIconsByServiceName);

export default ({ serviceName }) => {
  const SocialIcon = socialIconsByServiceName[`${serviceName}`];
  return <SocialIcon />;
};

export { VALID_SOCIAL_LINK_SERVICE_NAMES };
